import type { RouteResource } from '@atlassian/react-resource-router';
import { themePreferenceResource } from '@jira/router-resources__theme-preference/src/useThemePreference.tsx';

export const jiraSpaResources = (): RouteResource[] => [themePreferenceResource];
